import React, { useState, useEffect, FC } from 'react';

import { LandingControlButtons } from '@/components/modules/product-page/ui/landing-control-buttons';
import { StandardControlButtons } from '@/components/modules/product-page/ui/standard-control-buttons';

import { TFullRentProduct } from '@/entities/product';

import { StyledSticky, StyledButtons } from './styled';

type TProps = {
    product: TFullRentProduct;
    isLand: boolean;
};

export const StickyBottomNavigation: FC<TProps> = ({ product, isLand }) => {
    const [hidden, setHidden] = useState(false);

    const handleScroll = () => {
        const documentHeight = document.body.scrollHeight;

        const currentScroll = window.scrollY + window.innerHeight;

        setHidden(currentScroll + 200 > documentHeight);
    };

    useEffect(() => {
        document.addEventListener('scroll', handleScroll);

        return () => document.removeEventListener('scroll', handleScroll);
    }, []);

    return (
        <StyledSticky hidden={hidden}>
            <StyledButtons>
                {isLand ? (
                    <LandingControlButtons product={product} />
                ) : (
                    <StandardControlButtons product={product} isStickyBottom />
                )}
            </StyledButtons>
        </StyledSticky>
    );
};
